import { Component, OnChanges, Input, Output, EventEmitter, AfterViewInit, ViewChild, OnInit, HostListener, ElementRef } from '@angular/core';
import { PedidoModel } from 'src/app/models/pedido.model';
import { ProductosPModel } from '../../../models/productosP.model';
import { ImpuestosModel } from '../../../models/impuestos.model';
import { SmallshiService } from '../../../services/smallshi.service';
import { UrlPauService } from '../../../services/url-pau.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { DataDeliveryService } from '../../../services/data-delivery.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationService } from '../../../services/location.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { environment } from 'src/environments/environment';
import { alfreditoService } from "../../../services/task-alfredito.service";
import { CarritoControlerService } from 'src/app/services/carrito-controler.service';
import { HttpHeaders } from '@angular/common/http';



@Component({
  selector: 'app-carrito',
  templateUrl: './carrito.component.html'
})
export class CarritoComponent implements OnChanges, OnInit {
  @Input() productos: any[];
  @Input() cantidadProd: number;
  @Input() idComercio = '';
  @Input() urlRetorno = '';
  @Input() nombre_tienda = '';
  @Input() rnc = '';
  @Input() cedula = '';
  @Output() finalizarPedido: EventEmitter<boolean>;
  @ViewChild("placesRef") placesRef: GooglePlaceDirective;
  environment = environment;
  numeroHabitacion = 0;
  pedidoStr: string = '';
  load_flag: boolean = true;
  validar_url: boolean;
  nuevoPedido: PedidoModel[] = [];
  productosPedido: ProductosPModel[] = [];
  impuestosPedido: ImpuestosModel[] = [];
  idPedido: string = '';
  numProductos = 0;
  valorFactura = 0;
  flagHilo = false;
  flagMedioPago = false;
  flagTipoPago = 0;
  finalizar: boolean = false;
  validate_error = true;
  public class0 = false;
  public class1 = true;
  public flujo = '';
  public location = [];
  public location2 = [];
  public urlBanco = '';
  public shiwallet: number;
  public controlDelivery = 0;
  public provincias: any[] = [];
  public distritos: any[] = [];
  public corregimientos: any[] = [];
  public barrios: any[] = [];
  public formularioDelivery: FormGroup;
  public deliveryship: number;
  public btnDelivery: boolean;
  public direccion: string;
  public msnDelivery: string;
  public flagCobertura: boolean;
  public ValorImpuestos: number;
  public vaLFacTotal: number;
  public latComercio: number;
  public lngComercio: number;
  public options = {
    types: [],
    componentRestrictions: { country: 'CO' }
  };
  //formularioDelivery2: FormGroup;

  public disabled_btn = true;
  public error = { show: false, message: '' };
  public idSDCC = '231'; // desa 283   // prod 231



  @HostListener('document:click', ['$event'])
  clickout(event) {
    const IS_BUTTON = event.target.getAttribute('data-button')
    const IS_INSIDE_SHOPPING_CART = this.eRef.nativeElement.contains(event.target)
    if (!IS_INSIDE_SHOPPING_CART && !IS_BUTTON) this.toggleCarrito(false)

  }

  constructor(public small: SmallshiService,
    private pau: UrlPauService,
    private fb: FormBuilder,
    private delivery: DataDeliveryService,
    private lct: LocationService,
    private modal: NgbModal,
    private alfreditoService: alfreditoService,
    private carritoControlerService: CarritoControlerService,
    private eRef: ElementRef) {

    this.finalizarPedido = new EventEmitter;
    this.validar_url = true;
    this.load_flag = true;
    this.flagCobertura = true;
    this.latComercio = this.small.tienda_lat;
    this.lngComercio = this.small.tienda_lng;
    this.pau.getUrlBanco().subscribe((respUrl: any) => this.urlBanco = respUrl);
    this.SelectMedioPago('cash');
    this.flujo = small.flujo;
    this.shiwallet = small.shiwallet;
    this.controlDelivery = small.controlDelivery;
    this.location = lct.getCurrentLocation();
    // console.log('op 1: ', this.location);

    this.getProvincia();
    this.crearFormulario();

    if (small.validaMesa) {
      this.tipoEntrega(2);
      this.btnDelivery = false;
      this.disabled_btn = false;
    } else {
      this.btnDelivery = true;
    }

  }

  ngOnInit(): void {
    this.carritoControlerService.closeCarrito$.subscribe((state) => {
      let text = '';
      text = (state) ? 'show' : 'hide';
      ($ as any)('#collapseExample').collapse(text)
    })
  }

  toggleCarrito(state: boolean) {
    this.carritoControlerService.closeCarrito(state)
  }

  public handleAddressChange(address: Address) {
    console.log(address);
    this.location[0] = address.geometry.location.lat();
    this.location[1] = address.geometry.location.lng();
    this.geocoder(address.geometry.location.lat(), address.geometry.location.lng());
  }

  ngOnChanges() {
    // this.numProductos = 0;
    // this.valorFactura = 0;
    // //console.log('retornar: ', this.urlRetorno);
    // for (let prodCarrito of this.productos) {
    //   this.numProductos = prodCarrito.cantidad + this.numProductos;
    //   this.valorFactura = (prodCarrito.cantidad * prodCarrito.price) + this.valorFactura;
    //   //console.log(this.small.formaEntrega, ' espacio ', this.small.codCliente);
    // }
    this.calcularTotal();
  }

  calcularTotal() {
    this.numProductos = 0;
    this.valorFactura = 0;
    this.ValorImpuestos = 0;
    for (let prodCarrito of this.productos) {
      const impuestosCalculo = (prodCarrito.impuesto_porcentaje * prodCarrito.price) / 100;
      this.numProductos = prodCarrito.cantidad + this.numProductos;
      this.ValorImpuestos += (prodCarrito.cantidad * impuestosCalculo);
      this.valorFactura += (prodCarrito.cantidad * prodCarrito.price);
      //console.log(this.small.formaEntrega, ' espacio ', this.small.codCliente);
    }
    this.vaLFacTotal = this.valorFactura + this.ValorImpuestos;
  }
  crearFormulario() {
    if (this.controlDelivery == 1) {
      this.formularioDelivery = this.fb.group({

        _forma_entrega: ['', Validators.required], // [Validators.required, Validators.pattern('^[a-z0-9-]+$')]
        _email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
        _nombres: ['', Validators.required],
        _apellidos: [''],
        _celular: ['', Validators.required],
        _cedula: ['', [Validators.required, Validators.pattern('^[a-z0-9-]+$')]],
        _provincia: ['', Validators.required],
        _distrito: ['', Validators.required],
        _corregimiento: ['', Validators.required],
        _barrio: [''],
        _direccion: ['', Validators.required],
        _obs_entrega: [''],
        _calle: ['', Validators.required],
        _casaApto: ['', Validators.required]
      });
    } else {
      this.formularioDelivery = this.fb.group({
        _forma_entrega: ['', Validators.required],
        _direccion: [''],
        _calle: [''],
        _casaApto: ['']
      });
    }

  }
  sellectpais() {
    this.options.componentRestrictions.country = this.small.codigoPais;
    console.log(this.options);
  }
  SelectMedioPago(tipoP) {
    //console.log(tipoP);
    switch (tipoP) {
      case 'card':
        this.class0 = true;
        this.class1 = false;
        this.flagTipoPago = 1;

        break;
      case 'cash':
        this.class0 = false;
        this.class1 = true;
        this.flagTipoPago = 2;

        break;
      default:
        break;
    }
  }
  confPedido(x) {
    if (x === 1) {
      this.flagMedioPago = false;
    } else {
      this.flagMedioPago = true;
    }
  }
  crearPedido() {
    if (environment.options.isHotel && !this.numeroHabitacion) return this.showErrors('La habitación es requerida');
    this.load_flag = false;
    this.small.getUrlPauService(this.idPedido,
      this.valorFactura.toFixed(2),
      this.numProductos.toString(),
      this.validar_url,
      this.idComercio,
      this.nombre_tienda,
      this.numeroHabitacion
    ).subscribe((respUrl: any) => {
      // if (respUrl.status) {
      this.flagHilo = true;
      this.validar_url = false;
      this.cargarPedido();
      this.confirmarPedido();
      this.finalizar = true;
      // }
      this.finalizarPedido.emit(this.finalizar);
    });
  }

  showErrors(message: string) {
    this.error = { show: true, message: message };
    setTimeout(() => {
      this.error = { show: false, message: '' };
    }, message.length * 100)
  }

  crearPedidoComercio() {
    //let urlnegocio = `https://wa.me/${this.small.telefonoCliente}?text=`

    this.load_flag = false;
    this.cargarPedido();
    this.confirmarPedidoComercio();


  }
  confirmarPedidoComercio() {
    let urlnegocio = '';
    this.small.crearPedido(this.pedidoStr, this.idComercio)
      .subscribe((resp: any) => {
        if (resp.status) {
          if (this.idComercio === this.idSDCC) this.idPedido = resp.noPedido;
          this.idPedido = resp.data[0].id;
          this.validate_error = true;
          this.finalizar = false;
          if (this.controlDelivery == 1) {
            this.delivery.pedido_id = this.idPedido;
            this.delivery.guardarDataDelivery().subscribe((resp_delivery: any) => {
            });
          }
          this.finalizar = true;
        } else {
          Swal.fire({
            icon: 'error',
            text: `Error al crear el pedido: ${resp.message}`
          });
          this.validate_error = true;
          this.finalizar = false;
        }
        this.load_flag = true;
        if (this.shiwallet === 1) {
          urlnegocio = `https://wa.me/${this.urlBanco}?text=Pe.${this.idPedido}Co.${this.small.idTienda}`;
        } else {
          urlnegocio = `https://wa.me/${this.small.tlfTienda}?text=${this.urlformatProductos()}`;
        }
        this.small.urlRetorno = urlnegocio;
        this.finalizarPedido.emit(this.finalizar);
      });

  }



  confirmarPedido() {
    this.small.crearPedido(this.pedidoStr, this.idComercio)
      .subscribe((resp: any) => {
        if (this.idComercio === this.idSDCC) {
          if (resp.status) this.idPedido = resp.noPedido;
          else {
            this.load_flag = true;
            Swal.fire({
              icon: 'error',
              text: `Error al crear el pedido: ${resp.message}`
            });
            this.finalizar = false;
            this.validate_error = false;
          }

        } else {
          if (resp.status) { this.idPedido = resp.data[0].id }
          else {
            this.productos = resp.data;
            Swal.fire({
              icon: 'error',
              title: 'Oops algo ocurrió...',
              text: resp.message
            });
            this.validate_error = true;
            this.finalizar = false;
          }
        }
        if (this.controlDelivery == 1) {
          this.delivery.pedido_id = this.idPedido;
          this.delivery.guardarDataDelivery().subscribe();
        }
        if (this.validate_error) {
          this.small.getUrlPauService(
            this.idPedido,
            this.valorFactura.toFixed(2),
            this.numProductos.toString(),
            this.validar_url,
            this.small.idTienda,
            this.nombre_tienda)
            .subscribe((respUrl: any) => {

              this.load_flag = true;
              this.finalizar = true;
              this.finalizarPedido.emit(this.finalizar);
            });
        }


      }, (error) => { console.log(error as any); });

  }
  cargarPedido() {
    const cargaPedido: PedidoModel = {
      token: '', baseImponible: 0, total: 0, idCliente: '',
      RNC: '', tipoPedido: '', cedula: '', direccion: '', latitud: 0, longitud: 0, des_lat: 0, des_lon: 0, detallesPedido: [],
      tipocliente: 0, dtoaplicado: 0, shop_mesa_id: 0, pordto: 0, proaplicada: 0, porpropina: 0,
      iddto: 0, idpropina: 0, observaciones: '', impuestos: [], tienda_id: 0, id_json: '', idhentrega: '', formaEntrega: ''
    };
    this.cargarProductos();
    cargaPedido.token = 'bot';
    cargaPedido.baseImponible = this.valorFactura;
    cargaPedido.total = this.vaLFacTotal;
    cargaPedido.idCliente = (this.small.codCliente === '' ? 'anonimo' : this.small.codCliente);

    cargaPedido.RNC = this.rnc;
    cargaPedido.formaEntrega = this.small.formaEntrega;
    cargaPedido.cedula = this.cedula;
    cargaPedido.direccion = this.delivery.calle + '--sil--' + this.delivery.casa_apto;
    cargaPedido.latitud = this.location[0];
    cargaPedido.longitud = this.location[1];
    cargaPedido.des_lat = this.location[0];
    cargaPedido.des_lon = this.location[1];
    cargaPedido.tipocliente = 0;
    cargaPedido.dtoaplicado = 0;
    cargaPedido.shop_mesa_id = this.small.mesaComercio;
    cargaPedido.pordto = 0;
    cargaPedido.proaplicada = 0;
    cargaPedido.porpropina = 0;
    let obs = ((document.getElementById("observacionesHtml") as HTMLInputElement).value);
    cargaPedido.observaciones = obs;
    cargaPedido.iddto = 0;
    cargaPedido.idpropina = 0;
    cargaPedido.idhentrega = this.small.idhentrega;
    cargaPedido.tienda_id = parseInt(this.idComercio);
    cargaPedido.id_json = this.small.idJsonPau;
    this.nuevoPedido.push(cargaPedido);
    if (this.idComercio != this.idSDCC) {
      //console.log('hola carrito...',this.nuevoPedido[0]);
      this.pedidoStr = this.small.ObjecttoParams(this.nuevoPedido[0]);
      this.pedidoStr = this.pedidoStr.replace('detallesPedido=', 'detallesPedido=' + JSON.stringify(this.productosPedido));
      this.pedidoStr = this.pedidoStr.replace('impuestos=', 'impuestos=' + JSON.stringify(this.impuestosPedido));
    } else {
      this.nuevoPedido[0].detallesPedido = this.productosPedido;
      this.nuevoPedido[0].impuestos = this.impuestosPedido;
      this.pedidoStr = JSON.stringify(this.nuevoPedido[0]);
    }

  }
  cargarProductos() {
    let cantidad = [];
    let ids_smallshi = [];
    for (let x of this.productos) {
      if (x.cantidad == 0) continue;

      const prodPedido: ProductosPModel = {
        idProducto: '', canjeo_tarjeta: '', usupos: '', cantidad: 0,
        idtalla: '', dto: '', promocion: "", iddto: 0, pordto: 0,
        shop_menus_id: "", list_reg_id: "", id_listanovio: "", observaciones: "",
        dtoaplicado: 0, reduction_cupon: 0, tipo: "", precio: "", complementos: [],
        tallas: []
      };
      prodPedido.idProducto = x.product_id;
      prodPedido.cantidad = x.cantidad;
      prodPedido.shop_menus_id = x.category_id;
      prodPedido.precio = x.price;
      this.productosPedido.push(prodPedido);
      if (this.impuestosPedido.length > 0) {
        let indexImp = 0;
        for (let y = 0; y < this.impuestosPedido.length; y++) {
          indexImp = 0;
          if (this.impuestosPedido[y].idi === x.impuesto_id) {
            indexImp = y + 1;
          }
        }

        if (indexImp > 0) {
          let calc_impuesto = 0;
          calc_impuesto = x.cantidad * ((x.price * x.impuesto_porcentaje) / 100);
          calc_impuesto += parseFloat(this.impuestosPedido[indexImp - 1].suma);
          this.impuestosPedido[indexImp - 1].suma = calc_impuesto.toString();

        } else {
          let calc_impuesto = 0;
          calc_impuesto = x.cantidad * ((x.price * x.impuesto_porcentaje) / 100);
          const impuPedido: ImpuestosModel = { idi: '', suma: '' };
          impuPedido.idi = x.impuesto_id;
          impuPedido.suma = calc_impuesto.toString();
          this.impuestosPedido.push(impuPedido);

        }

      } else {
        let calc_impuesto = 0;
        calc_impuesto = x.cantidad * ((x.price * x.impuesto_porcentaje) / 100);
        const impuPedido: ImpuestosModel = { idi: '', suma: '' };
        impuPedido.idi = x.impuesto_id;
        impuPedido.suma = calc_impuesto.toString();
        this.impuestosPedido.push(impuPedido);

      }
      cantidad.push(x.cantidad)
      ids_smallshi.push(parseInt(x.product_id))

    } //for padre

    if (!environment.options.isHotel) return;
    let cantidadArray = {}
    let id_smallshiArray = {}
    for (let i = 0; i < cantidad.length; i++) {
      const position = '[' + i + ']'
      cantidadArray['cantidad' + position] = cantidad[i]
      id_smallshiArray['id_smallshi' + position] = ids_smallshi[i]
    }
    let hoy = new Date();
    this.crearTareasAlfredito(
      environment.options.inspector_id,
      `${hoy.getFullYear()}-${hoy.getMonth() + 1}-${hoy.getDate()}`,
      this.numeroHabitacion,
      environment.options.administrador,
      cantidadArray,
      id_smallshiArray,
      ((document.getElementById("observacionesHtml") as HTMLInputElement).value)
    );

  }


  urlformatProductos() {
    let cadenaWsp = '';
    cadenaWsp = `Nuevo pedido (${this.small.nombreTienda})\n---- Pedido: ${this.idPedido} ----\n \n`;
    this.productos.forEach(element => {
      if (element.cantidad > 0) {
        cadenaWsp += ` ${element.cantidad} X ${element.title} -  ($ ${element.price * element.cantidad})\n`;
      }
    });
    cadenaWsp += `\n*Total: $ ${this.valorFactura}*\nForma de pago: No especificada`;
    return encodeURI(cadenaWsp);
  }


  openModal(contenido) {
    this.small.geoCode(this.location[0], this.location[1]).subscribe((posInicial: any) => {
      if (posInicial.status === 'OK') {
        this.geocoder(this.location[0], this.location[1]);
        //console.log(posInicial.results[0].formatted_address);
        this.direccion = posInicial.results[0].formatted_address;
      } else {
        console.log('no encontramos tu ubicación.');
      }

    });
    this.modal.open(contenido);
  }
  setdeliveryIship(idDelivery) {
    //console.log('Selected delivery: ', this.formularioDelivery.get('_forma_entrega').value);
    this.deliveryship = this.formularioDelivery.get('_forma_entrega').value;
    if (this.deliveryship == 1) {
      this.sellectpais();
      this.formularioDelivery.patchValue({ _calle: this.direccion });
    }
  }

  getProvincia() {
    this.small.getProvincia(1).subscribe((data: any) => {
      this.provincias = data.data;
    });
  }
  getDistrito(idProvincia) {

    this.delivery.provincia = this.provincias[idProvincia.target.selectedIndex - 1].provincia;
    this.delivery.id_provincia = this.provincias[idProvincia.target.selectedIndex - 1].id_provincia;

    this.small.getDistrito(idProvincia.target.value).subscribe((data: any) => {
      this.distritos = data.data;

    });
  }
  getCorregimiento(idDistrito) {

    this.delivery.id_distrito = this.distritos[idDistrito.target.selectedIndex - 1].distrito;
    this.delivery.distrito = this.distritos[idDistrito.target.selectedIndex - 1].id_distrito;

    this.small.getCorregimiento(idDistrito.target.value).subscribe((data: any) => {
      this.corregimientos = data.data;

    });
  }
  getBarrio(IdCorregimiento) {

    this.delivery.correguimiento = this.corregimientos[IdCorregimiento.target.selectedIndex - 1].corregimiento;
    this.delivery.id_correguimiento = this.corregimientos[IdCorregimiento.target.selectedIndex - 1].id_corregimiento;

    this.small.getBarrio(IdCorregimiento.target.value).subscribe((data: any) => {
      this.barrios = data.data;
    });
  }
  setBarrio(barrio) {
    this.delivery.barrio = this.barrios[barrio.target.selectedIndex - 1].barrio;
    this.delivery.id_barrio = this.barrios[barrio.target.selectedIndex - 1].id_barrio;
  }
  guardarFormDelivery() {
    if (this.formularioDelivery.valid) {
      this.delivery.forma_entrega = this.formularioDelivery.get('_forma_entrega').value;
      this.delivery.direccion = this.formularioDelivery.get('_direccion').value;
      this.delivery.observaciones_delevery = this.formularioDelivery.get('_obs_entrega').value;
      this.delivery.cedulaCliente = this.formularioDelivery.get('_cedula').value;
      this.delivery.nombre = this.formularioDelivery.get('_nombres').value;
      this.delivery.apellido = this.formularioDelivery.get('_apellidos').value;
      this.delivery.celular = this.formularioDelivery.get('_celular').value;
      this.delivery.email = this.formularioDelivery.get('_email').value;
      this.delivery.calle = this.formularioDelivery.get('_calle').value;
      this.delivery.casa_apto = this.formularioDelivery.get('_casaApto').value;
      this.modal.dismissAll();
      this.disabled_btn = false;
      this.tipoEntrega(this.formularioDelivery.get('_forma_entrega').value);
    } else {
      console.log('el Formulario no esta completo');
    }
  }
  guardarFormDelivery2() {
    if (this.formularioDelivery.invalid) return console.log('el Formulario no esta completo');

    const ES_DELIVERY = this.formularioDelivery.get('_forma_entrega').value == 1;
    const EXISTE_APARTAMENTO = this.formularioDelivery.get('_casaApto').value != '';
    const HAY_COBERTURA = this.flagCobertura
    if ((ES_DELIVERY && !EXISTE_APARTAMENTO && !HAY_COBERTURA)) {
      Swal.fire({
        icon: 'error',
        title: 'Oops algo ocurrió...',
        text: 'Por favor Validar: \r 1. Diligenciar los campos de dirección. \n\r 2. Casa o apartamento. \r 3. Validar que estes en zona de cobertura.'
      });
    } else {
      this.delivery.forma_entrega = this.formularioDelivery.get('_forma_entrega').value;
      this.delivery.direccion = this.formularioDelivery.get('_direccion').value;
      this.delivery.calle = this.formularioDelivery.get('_calle').value;
      this.delivery.casa_apto = this.formularioDelivery.get('_casaApto').value;
      this.modal.dismissAll();
      this.disabled_btn = false;
      this.tipoEntrega(this.formularioDelivery.get('_forma_entrega').value);
    }


  }
  // ------------------------------------ validaciones ------------------------------- //
  get forma_entrega_noValido() {
    return this.formularioDelivery.get('_forma_entrega').invalid && this.formularioDelivery.get('_forma_entrega').touched;
  }
  get correoNoValido() {
    return this.formularioDelivery.get('_email').invalid && this.formularioDelivery.get('_email').touched;
  }
  get nombreNoValido() {
    return this.formularioDelivery.get('_nombres').invalid && this.formularioDelivery.get('_nombres').touched;
  }
  get apellidoNoValido() {
    return this.formularioDelivery.get('_apellidos').invalid && this.formularioDelivery.get('_apellidos').touched;
  }
  get cedulaNoValido() {
    return this.formularioDelivery.get('_cedula').invalid && this.formularioDelivery.get('_cedula').touched;
  }
  get celularNoValido() {
    return this.formularioDelivery.get('_celular').invalid && this.formularioDelivery.get('_celular').touched;
  }
  get provinciaNoValido() {
    return this.formularioDelivery.get('_provincia').invalid && this.formularioDelivery.get('_provincia').touched;
  }
  get calleNoValido() {
    return this.formularioDelivery.get('_calle').invalid && this.formularioDelivery.get('_calle').touched;
  }
  get aptoNoValido() {
    return this.formularioDelivery.get('_casaApto').invalid && this.formularioDelivery.get('_casaApto').touched;
  }
  // ------------------------------------ validaciones ------------------------------- //

  cerrarDelivery() {
    this.modal.dismissAll();
  }
  tipoEntrega(tipoEntrega) {
    this.small.formaEntrega = tipoEntrega;
  }

  move(evento) {
    this.location[0] = evento.coords.lat;
    this.location[1] = evento.coords.lng;

    this.small.geoCode(this.location[0], this.location[1]).subscribe((pos: any) => {

      if (pos.status === 'OK') {
        this.geocoder(evento.coords.lat, evento.coords.lng);
        this.direccion = pos.results[0].formatted_address;
        this.formularioDelivery.patchValue({ _calle: this.direccion });
      } else {
        console.log('no encontramos tu ubicación.');
      }
    });
  }

  geocoder(lat, lng) {
    const distancia = this.small.getDistance(lat, lng);
    const distanciaKM = (distancia / 1000);
    const IsPickUp = this.small.radioDelivery == null;
    const isDeliveryInCoberturaArea = this.small.radioDelivery > distanciaKM
    if (IsPickUp || isDeliveryInCoberturaArea) {
      this.msnDelivery = '';
      this.flagCobertura = true;
    } else {
      this.flagCobertura = false;
      this.msnDelivery = 'No tenemos cobertura en esta zona.';
    }
  }

  crearTareasAlfredito(inspector_id, fecha, habitacion, administrador, cantidad, id_smallshi, observaciones) {
    if (!observaciones || observaciones == '') observaciones = 'No hay Observaciones';
    const body = { inspector_id, fecha, habitacion, administrador, ...cantidad, ...id_smallshi, observaciones }

    this.alfreditoService.crearTareas(body).subscribe(res => {
      console.log('respuesta creando tarea: ', res)
    });
  }

  cerrar() {
    window.location.href = this.urlRetorno;
  }
}
